import axiosInstance from '@/services/axiosInstance'
// import mock from '@/services/mock/index'

async function deleteWorkflow (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    
  } else {
    const req = {
      url: '/api/flujoaprobacion/eliminarflujo',
      method: 'DELETE',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { deleteWorkflow }
